module.exports = __webpack_public_path__ + "assets/img/icon5.8bfccf19.png";